define('components/news',[
    'jquery',
    'components/decorator'
], function($, decorator) {

    $.extend(companyInfo.decorators, {

        'news': function() {
            var container = this;
            var query = this.getAttribute('data-query');
            var panel = $(this).closest('.panel');
            var item;
            var date;
            var entry;
            var i;
            $(container).addClass('loading');
            $.getJSON('https://ajax.googleapis.com/ajax/services/search/news?v=1.0&q=' + encodeURIComponent(query) + '&rsz=8&ned=nl_nl&scoring=d&hl=nl&callback=?').done(function(data) {
                if (data.responseStatus == 200 && data.responseData.results.length > 0) {
                    for (i = 0; i < data.responseData.results.length; i++) {
                        item = document.createElement('div');
                        item.className = 'newsitem';
                        entry = data.responseData.results[i];
                        date = new Date(entry.publishedDate);
                        item.innerHTML = '<h3><a href="' + entry.unescapedUrl + '" target="_blank">' + entry.titleNoFormatting + '<\/a><\/h3>' +
                                         '<p class="newsitem-text">' + entry.content + '</p>' +
                                         '<p class="meta">' + entry.publisher + ' ' + date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear() + '</p>';
                        container.appendChild(item);
                    }
                } else {
                    var noResults = container.getAttribute('data-no-results');
                    item = document.createElement('div');
                    item.innerHTML = '<p>' + noResults + '</p>';
                    container.appendChild(item);
                }
                $(container).removeClass('loading');
                decorator.run(panel);
            });
        }

    });

});
